import React , {Component} from 'react';
import Input from '../../Components/UI/Forms/Input/Input';
import Button from '../../Components/UI/Button/Button';
import axios from '../../axios-instance';
import Spinner from '../../Components/UI/Spinner/Spinner';
import classes from './Contact.css';
import Hero from '../../Components/UI/Hero/Hero';
import infoImg from '../../Assets/Images/img9.png';
import Aux from '../../Hoc/Aux/Aux';
import Footer from '../../Components/Footer/Footer';

class Contact extends Component {

    state = {
        contactForm: {
            fname: {
                label: 'First Name',
                elementType: "input",
                elementConfig: {
                    type: 'text',
                    placeholder: 'First Name',
                },
                value: '',
                validation: {
                    required: true,
                },
                valid: false,
                touched: false,

            },
            lname: {
                label: 'Last Name',
                elementType: "input",
                elementConfig: {
                    type: 'text',
                    placeholder: 'Last Name',
                },
                value: '',
                validation: {
                    required: true,
                },
                valid: false,
                touched: false,

            },
            email: {
                label: 'Email Address',
                elementType: "input",
                elementConfig: {
                    type: 'email',
                    placeholder: 'Email',
                },
                value: '',
                validation: {
                    required: true,
                },
                valid: false,
                touched: false,
            },
            phone: {
                label: 'Phone Number',
                elementType: "input",
                elementConfig: {
                    type: 'text',
                    placeholder: 'Phone',
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 10,
                    maxLength: 10,
                },
                valid: false,
                touched: false,

            },
        },
        formIsValid: false,
        loading: false,
    };


    checkValidity = (value, rules ) => {
        let isValid = true;

        if(!rules) { return true }

        if(rules.required) {
            isValid = value.trim() !== '' && isValid;
        }

        if(rules.minLength) {
            isValid = value.length >= rules.minLength && isValid;
        }

        if(rules.maxLength) {
            isValid = value.length <= rules.maxLength && isValid;
        }

        return isValid;
    };

    orderHandler = (event) => {
        event.preventDefault();
        this.setState( { loading: true } );
        const formData = {};
        for(let formDataIdentifire in this.state.contactForm) {
            formData[formDataIdentifire] = this.state.contactForm[formDataIdentifire].value;
        };

        const data = {
            formData: formData,
        };

        axios.post( '/people.json', data )
            .then( response => {
                this.setState( { loading: false} );
                this.props.history.push('/');
            } )
            .catch( error => {
                this.setState( { loading: false} );
            } );
    };


    inputChangeHandler = (event, inputIdentifier) => {
        const updatedContactForm = {...this.state.contactForm};
        const updatedFormElement = {...updatedContactForm[inputIdentifier]};
        updatedFormElement.value = event.target.value;
        updatedFormElement.valid = this.checkValidity(updatedFormElement.value, updatedFormElement.validation);
        updatedFormElement.touched = true;
        updatedContactForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for(let inputIdentifier in updatedContactForm) {
            formIsValid = updatedContactForm[inputIdentifier].valid && formIsValid;
        }
        // console.log('[updatedFormElement]',updatedFormElement)

        this.setState({
            contactForm: updatedContactForm,
            formIsValid,
        });
    };


    render() {
        let toElementArray = Object.keys(this.state.contactForm)
            .map(keyName => {
                return {
                    id: keyName,
                    config: this.state.contactForm[keyName]
                }
            });
        // console.log('Object values', toElementArray);
        let form = (
            <form onSubmit={this.orderHandler}>
                {toElementArray.map(formElement => (
                    <Input key={formElement.id}
                           elementType={formElement.config.elementType}
                           value={formElement.config.value}
                           label={formElement.config.label}
                           elementConfig={formElement.config.elementConfig}
                           invalid={!formElement.config.valid}
                           shouldValidate = {formElement.config.validation}
                           touched={formElement.config.touched}
                           changed={(event) => this.inputChangeHandler(event,formElement.id)}
                    />
                ))}
                <Button btnType="Info" disabled={!this.state.formIsValid}>Submit RSVP</Button>
            </form>
        );
        if(this.state.loading) {
            form = <Spinner />
        }
        return (
            <Aux>
                <Hero
                    title="Info Session"
                    classType="hero-overview"
                    img={infoImg}
                />
                <div className="section">
                    <div className={["contanier", classes.ContactData].join(' ')}>
                        <div className="columns">
                            <div className="column">
                                <div className="content">
                                    <h1>Sign up to Attend next Event</h1>
                                    {form}
                                </div>
                            </div>
                            <div className="column">
                                <div className="content">
                                    <h1>Next Session: Every Saturday</h1>
                                    <p>
                                        You will have the opportunity to see the
                                        site and where we train students to become
                                        full stack web developers. In addition, meet
                                        the ProCode instructors and come prepared
                                        with questions you may have about how we train,
                                        what you will learn and how we connect students
                                        to employers in the marketplace to become a
                                        part of the web development boom. Come and talk
                                        to some of our current students and see for yourself!
                                    </p>
                                    <h1>Benefits of Coming to the Info Session</h1>
                                    <ul>
                                        <li>See our modern training facility</li>
                                        <li>Attend in-person only</li>
                                        <li>Meet the ProCode instructors and staff</li>
                                        <li>Meet some of the current students</li>
                                        <li>Learn about our pricing & discounts</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Aux>
                    <Footer />
                </Aux>
            </Aux>
        )

    }
};

export default Contact;


// WEBPACK FOOTER //
// ./src/Containers/ContactData/Contact.js